import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  CircularProgress,
  Grid,
  Card,
  Tabs,
} from '@mui/material';
import {
  addManufacturerRoleToExistingFirmAction,
  getBuyerRolesAction,
} from '../../v2/Onboarding/auth/action';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import { searchByTypes } from '../../utils/settings';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Row } from 'antd';
import StatusChip from '../../v2/MUI_custom_component/chips/StatusChip';
import StandardChip from '../../v2/MUI_custom_component/chips/StandardChip';
import { toast } from 'react-toastify';
import CustomTab from '../../v2/MUI_custom_component/Tab/CustomTab';
import OnboardNowPrompt from './../../v2/BCMOrder/Components/OnboardNowPrompt';
import CustomButton from '../../v2/MUI_custom_component/Button/CustomButton';
import SelectRoleModal from '../../v2/BCMOrder/SelectRoleModal';
import { toCapitalized } from '../../v2/Utils/Capitalize';
import {
  getUserInventoryTransactionsStpInfoAction,
  searchCompanyAction,
} from '../../screen/distributor/action/util_action';
import { trackAnalyticsEvent } from '../../utils/clevertap/clevertapUtils';

const SelectSTP = () => {
  const [CompanyRoleData, setCompanyRoleData] = useState([]);
  const [influencerRoles, setInfluencerRoles] = useState([]);
  const [influencerRolesExists, setInfluencerRolesExists] = useState(false);
  const [influencerTabSelected, setInfluencerTabSelected] = useState(false);
  const [openSelectRolesPrompt, setOpenSelectRolesPrompt] = useState(false);
  const [promptDetails, setPromptDetails] = useState({});
  const [activeTab, setActiveTab] = useState('My Network');
  const [loading, setLoading] = useState(false);

  const [userType, setUserType] = useState({});
  const [allBuyers, setAllBuyers] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const IS_SELL_TO_BUYER = true;
  const [isLoadingAllBuyers, setIsLoadingAllBuyers] = useState(false);
  const [activeRadio, setActiveRadio] = useState(searchByTypes['PHONE']);
  const [enteredValue, setEnteredValue] = useState('');
  const [allFoundCompanies, setAllFoundCompanies] = useState([]);
  const [userNotFound, setUserNotFound] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState('');
  const [errors, setErrors] = useState({});

  const { booking_details, seller_id, loginUser, noDownwardChain } =
    useSelector((state) => {
      return {
        booking_details: state.bcmOrderReducer.booking_details,
        seller_id: state.bcmOrderReducer.seller_id,
        loginUser: state.loginReducer.loginUser,
        noDownwardChain: state.bcmOrderReducer.noDownwardChain,
      };
    });
  const [sellerID, setSellerID] = useState(
    booking_details?.seller_company_id || seller_id,
  );

  // Track page load
  useEffect(() => {
    trackAnalyticsEvent('SELECT_STP_PAGE_LOADED', {
      screen_name: 'select_ship_to_party',
      seller_id: sellerID,
      action: 'page_load'
    });
  }, []);

  const getRoles = async () => {
    const params = new URLSearchParams();

    params.append('manufacturer_id', sellerID);
    params.append('is_ship_to_party', true);
    const { data, error, message } = await getBuyerRolesAction(
      sellerID,
      !IS_SELL_TO_BUYER,
      IS_SELL_TO_BUYER,
    );
    if (!error) {
      if (data.roles.length === 1 && data.roles[0].display_name === 'SELF') {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: true,
        });
      } else {
        dispatch({
          type: 'SET_NO_DOWNWARD_CHAIN',
          data: false,
        });
      }

      const influencerRoles = data.roles.filter(({ region_role_id }) => {
        return region_role_id === null;
      });

      setInfluencerRoles(influencerRoles);

      if (influencerRoles?.length > 0) {
        setInfluencerRolesExists(true);
        setInfluencerTabSelected(true);
        setSelectedRole('Influencer');
      } else {
        setInfluencerRolesExists(false);
      }

      setCompanyRoleData(
        data.roles.filter(({ region_role_id }) => region_role_id !== null),
      );
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  const getAggShilpkarDetailsByBuyer = async (userType) => {
    setIsLoadingAllBuyers(true);

    const payload = {
      firm_role_ids: influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [userType.firm_role_id],
      supplier_id: Number(sellerID),
    };

    const { data, error } = await getUserInventoryTransactionsStpInfoAction(
      payload,
    );
    setIsLoadingAllBuyers(false);
    if (!error) {
      setAllBuyers(data);
      setOriginalBuyersData(data);

      const hasActive = data.some(
        (section) => section.display_name === 'ACTIVE',
      );
      const hasDormant = data.some(
        (section) => section.display_name === 'DORMANT',
      );

      if (
        (hasActive || hasDormant) &&
        !data.find((section) => section.display_name === activeTab) &&
        activeTab !== 'My Network'
      ) {
        setActiveTab('My Network');
      }
    }
  };

  const searchByPhone = Number(activeRadio) === searchByTypes['PHONE'];
  const searchByName = Number(activeRadio) === searchByTypes['NAME'];
  const searchByPan = Number(activeRadio) === searchByTypes['PAN'];
  const searchByGst = Number(activeRadio) === searchByTypes['GST'];

  const searchInTableData = (searchValue) => {
    if (!searchValue || searchValue.trim() === '' || searchValue.length < 2) {
      return [];
    }

    if (!allBuyers || allBuyers.length === 0) return [];

    let foundResults = [];

    allBuyers.forEach((section) => {
      if (section.data && section.data.length > 0) {
        const filteredData = section.data.filter((row) => {
          if (searchByPhone) {
            return row.company_phone_number?.includes(searchValue);
          } else if (searchByName) {
            return row.company_name
              ?.toLowerCase()
              .includes(searchValue.toLowerCase());
          } else if (searchByPan) {
            return (
              row.company_pan
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              row.pancard_no?.toLowerCase().includes(searchValue.toLowerCase())
            );
          } else if (searchByGst) {
            return (
              row.company_gstin
                ?.toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              row.gstin?.toLowerCase().includes(searchValue.toLowerCase())
            );
          }
          return false;
        });

        if (filteredData.length > 0) {
          foundResults.push({
            ...section,
            data: filteredData,
          });
        }
      }
    });

    return foundResults;
  };
  const performSearch = async (value) => {
    if (!value || value.trim() === '' || value.length === 0) {
      resetTableData();
      setAllFoundCompanies([]);
      return;
    }

    const tableResults = searchInTableData(value);
    if (tableResults.length > 0) {
      setAllBuyers(tableResults);
      return;
    }
    const hasMyNetwork = allBuyers.some(
      (section) => section.display_name === 'My Network',
    );

    if (hasMyNetwork) {
      setAllBuyers(
        allBuyers.map((section) =>
          section.display_name === 'My Network'
            ? { ...section, data: [] }
            : section,
        ),
      );
    } else {
      setAllBuyers([{ display_name: 'My Network', data: [] }]);
    }

    if (searchByPhone) {
      if (value.length === 10 && /^\d{10}$/.test(value)) {
        setErrors({ ...errors, phone: null }); // Clear any existing phone error
        await searchUserByInfo(value);
      } else if (value.length !== 10) {
        setErrors({
          ...errors,
          phone: 'Please enter a valid 10 digit mobile number',
        });
      }
    } else {
      setErrors({ ...errors, phone: null }); // Clear phone error for non-phone searches
      await searchUserByInfo(value);
    }
  };

  useEffect(() => {
    if (!userType) return;
    getAggShilpkarDetailsByBuyer(userType);
  }, [userType]);

  useEffect(() => {
    if (influencerTabSelected && influencerRoles.length > 0) {
      getAggShilpkarDetailsByBuyer({});
    }
  }, [influencerTabSelected, influencerRoles]);

  useEffect(() => {
    if (allBuyers && allBuyers.length > 0) {
      setActiveTab('My Network');
    }
  }, [allBuyers]);

  const addUserToManufacturer = async (company_id, role) => {
    setOpenSelectRolesPrompt(false);
    setEnteredValue('');

    const payload = {
      manufacturer_id: role?.manufacturer_id || Number(sellerID),
      firm_role_id: role?.firm_role_id,
      region_role_map_id: role?.region_role_id,
      company_id: company_id,
    };

    const { data, error, message } =
      await addManufacturerRoleToExistingFirmAction(payload);

    if (!error) {
      setAllFoundCompanies([]);
      setEnteredValue('');

      return toast.success(message);
    } else {
      return toast.error(message);
    }
  };

  const searchUserByInfo = async (value, isExistingUser, selfRole) => {
    const payload = {
      supplier_id: Number(sellerID),
      firm_role_ids: influencerTabSelected
        ? influencerRoles.map((vv) => vv.firm_role_id)
        : [selfRole ? selfRole.firm_role_id : userType.firm_role_id],
    };

    if (isExistingUser) {
      payload.company_phone = value;
    } else {
      if (searchByPhone) payload.company_phone = value;
      if (searchByName) payload.company_name = value;
      if (searchByPan) payload.company_pan = value;
      if (searchByGst) payload.company_gstin = value;
    }
    setLoading(true);
    const { data, error, message } = await searchCompanyAction(payload);
    setLoading(false);
    if (!error) {
      if (
        data.length === 1 &&
        !data[0]?.onboarding_required &&
        isExistingUser
      ) {
        return setUser(data[0]);
      } else if (data.length === 1 && data[0]?.onboarding_required) {
        setAllFoundCompanies([]);
        return toast.error(
          <OnboardNowPrompt message={data[0].prompted_message} />,
          {
            position: toast.POSITION.TOP_LEFT,
            autoClose: true,
            closeButton: true,
            hideProgressBar: false,
            draggable: false,
            closeOnClick: false,
            style: {
              minWidth: '600px',
            },
          },
        );
      } else {
        setAllFoundCompanies(
          data.map((vv) => ({
            label: vv.name,
            value: vv.id,
            ...vv,
          })),
        );
      }
    } else return toast.error(message);
  };
  const debouncedSearch = useDebouncedCallback((value) => {
    setAllFoundCompanies([]);
    if (value.length === 0) {
      resetTableData();
      return;
    }

    performSearch(value);
  }, 1000);
  const [originalBuyersData, setOriginalBuyersData] = useState([]);
  const resetTableData = () => {
    if (originalBuyersData.length > 0) {
      setAllBuyers(originalBuyersData);
    }
    setAllFoundCompanies([]);
    // Ensure any pending searches are canceled
    if (debouncedSearch && debouncedSearch.cancel) {
      debouncedSearch.cancel();
    }
  };

  const checkVCPClubbingLogic = (data) => {
    const { role_details } = data;

    if (!role_details?.auto_create_mrm) {
      return setUser(data);
    } else if (role_details?.auto_create_mrm && role_details?.firm_role_id) {
      return addUserToManufacturer(data?.id, role_details);
    } else if (role_details?.auto_create_mrm && !role_details?.firm_role_id) {
      setPromptDetails(data);
      return setOpenSelectRolesPrompt(true);
    } else return toast.error(data.error_message);
  };
  const setUser = (data) => {
    const {
      geographic_info: {
        address_info,
        pincode_info,
        district_info,
        state_info,
        pricing_geography_info,
        location_info,
      },
      esi_info_with_operational_address

    } = data;

    const userObj = {
      company_name: data.name,
      company_id: data.id,
      company_phone_no: data.phone_no,
      user_esi_id : data.esi_info_with_operational_address[0]?.esi_info?.esi_id,
      company_address1: address_info.address_line_1,
      company_address2: address_info.address_line_2,
      company_address3: address_info.address_line_3,
      company_pincode: pincode_info.pincode_id,
      district_id: district_info.district_id,
      location_id: location_info.location_id,
      location_name: location_info.location_name,
      pricing_geography_id: pricing_geography_info.pricing_geography_id,
      pricing_geography_name: pricing_geography_info.pricing_geography_name,
      state_id: state_info.state_id,
      pancard_no:
        data.gstin_pan && data.gstin_pan.length === 10 && data.gstin_pan,
      gstin: data.gstin_pan && data.gstin_pan.length === 15 && data.gstin_pan,
      esi_info_with_operational_address
    };
    if (influencerTabSelected) {
      navigate('/inventory/checkout', {
        state: {
          bill_info: userObj,
          influencerTabSelected: influencerTabSelected,
          selectedRole: toCapitalized(selectedRole),
        },
      });
    } else {
      navigate('/inventory/selected-ship-to-party', {
        state: {
          buyerDetails: userObj,
          influencerTabSelected: influencerTabSelected,
          selectedRole: toCapitalized(selectedRole),
        },
      });
    }
  };
  const handleExistingShipToPartyClick = (row) => {    
    // Track ship-to-party selection
    trackAnalyticsEvent('STP_EXISTING_PARTY_SELECTED', {
      screen_name: 'select_ship_to_party',
      company_id: row.company_id,
      company_name: row.company_name,
      company_phone: row.company_phone_number,
      billing_type: row.billing,
      status: row.status,
      influencer_tab_selected: influencerTabSelected,
      selected_role: selectedRole,
      current_tab: activeTab,
      action: 'existing_party_selection'
    });
    
    setSelectedUser(row);
  };
  const notFoundAction = () => {
    return navigate('/onboard-buyer', {
      state: {
        isFromSearchStp: true,
      },
    });
  };
  const getCurrentTabData = () => {
    if (!allBuyers || allBuyers.length === 0) return null;

    const currentTabData = allBuyers.find(
      (section) => section.display_name === activeTab,
    );

    if (
      currentTabData &&
      currentTabData.data &&
      currentTabData.data.length > 0
    ) {
      return currentTabData;
    }

    if (activeTab === 'My Network' || !currentTabData) {
      const activeSection = allBuyers.find(
        (section) => section.display_name === 'ACTIVE',
      );
      const dormantSection = allBuyers.find(
        (section) => section.display_name === 'DORMANT',
      );

      if (activeSection && dormantSection) {
        return {
          display_name: 'My Network',
          data: [...(activeSection.data || []), ...(dormantSection.data || [])],
        };
      } else if (activeSection) {
        return {
          display_name: 'My Network',
          data: [...(activeSection.data || [])],
        };
      } else if (dormantSection) {
        return {
          display_name: 'My Network',
          data: [...(dormantSection.data || [])],
        };
      } else if (allBuyers.length > 0) {
        let combinedData = [];
        allBuyers.forEach((section) => {
          if (section.data && section.data.length > 0) {
            combinedData = [...combinedData, ...section.data];
          }
        });

        if (combinedData.length > 0) {
          return {
            display_name: 'My Network',
            data: combinedData,
          };
        }
      }
    }

    if (allBuyers.length > 0) {
      const firstTabWithData = allBuyers.find(
        (section) => section.data && section.data.length > 0,
      );
      if (firstTabWithData) {
        return firstTabWithData;
      }
    }

    return currentTabData || { display_name: activeTab, data: [] };
  };
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent:'end', 
          p: { xs: 2, md: 0 },
          mr: { xs: 0, md: 4 },
          position: {xs: 'sticky', md: 'relative'}, 
          top: 0, 
          zIndex: 1000, 
          boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
          background: {xs: '#FAFAFA', md: 'transparent'},
          pb: 0,
        }}>
        <CustomButton
            variant='filled'
            color='primary'
            label={loading ? 'Saving...' : 'Save'}
            disabled={!selectedUser || loading}
            sx={{ width: { xs: '100%', sm: 'auto' }}}
            onClick={() => {
              searchUserByInfo(selectedUser.company_phone_number, true);
            }}
            startIcon={
              loading ? (
                <CircularProgress
                  size={20}
                  color='inherit'
                />
              ) : null
            }
          />
      </Box>
      
      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Typography variant="h2" sx={{ mb: 2, fontWeight: 'bold' }}>
          Shipping Info
        </Typography>
        <SelectRoleModal
          allInfluencerRoles={influencerRoles}
          visible={openSelectRolesPrompt}
          onClose={() => {
            setOpenSelectRolesPrompt(false);
            setEnteredValue('');
          }}
          promptDetails={promptDetails}
          onFinish={addUserToManufacturer}
        />
        <Card
          sx={{
            padding: { xs: 2, sm: 2 },
            borderRadius: 2,
            mb: { xs: 2, sm: 3 },
            boxShadow: 'none'
          }}
        >
          <Grid
            spacing={2}
            container
            sx={{ p: 2, pb: { xs: 0, sm: 2 } }}
          >
            <Typography
              variant='labelD'
              gutterBottom
            >
              Select Role
            </Typography>
            <Grid
              items
              xs={12}
            >
              <Box sx={{ display: 'flex' }}>
              {CompanyRoleData.map((role) => {
                const isSelected = role.firm_role_id === userType.firm_role_id;
                return (
                  <StandardChip
                    key={role.firm_role_id}
                    label={role.display_name}
                    selected={isSelected}
                    onClick={() => {
                      setAllFoundCompanies([]);
                      setEnteredValue('');
                      setSelectedUser(null);
                      if (role.display_name?.toUpperCase() === 'SELF') {
                        setSelectedRole('Self');
                        searchUserByInfo(loginUser.phone_no, true, role);
                      } else {
                        setInfluencerTabSelected(false);
                        setSelectedRole(role.display_name);
                        setUserType({
                          firm_role_id: role.firm_role_id,
                          firm_role_name: role.display_name,
                        });
                      }
                    }}
                    sx={{ mr: 1 }}
                  />
                );
              })}

              {influencerRolesExists && (
                <StandardChip
                  label='Influencer'
                  selected={influencerTabSelected}
                  onClick={() => {
                    setInfluencerTabSelected(true);
                    setUserType({});
                    setSelectedUser(null);
                    setSelectedRole('Influencer');
                  }}
                  sx={{ mr: 1 }}
                />
              )}
              </Box>
            </Grid>
          </Grid>

          {!noDownwardChain &&
            (Object.keys(userType).length > 0 || influencerTabSelected) && (
              <>
                <FormControl>
                  <RadioGroup
                    aria-labelledby='demo-radio-buttons-group-label'
                    defaultValue={searchByTypes['PHONE']}
                    name='radio-buttons-group'
                    row
                    onChange={(e) => {
                      setActiveRadio(e.target.value);
                      setAllFoundCompanies([]);
                      setEnteredValue('');
                      setSelectedUser(null);
                      setErrors({ ...errors, phone: null });
                      resetTableData();
                    }}
                  >
                    <FormControlLabel
                      value={searchByTypes['PHONE']}
                      control={<Radio />}
                      label='Phone'
                    />

                    {!influencerTabSelected && (
                      <>
                        <FormControlLabel
                          value={searchByTypes['NAME']}
                          control={<Radio />}
                          label='Name'
                        />
                        <FormControlLabel
                          value={searchByTypes['PAN']}
                          control={<Radio />}
                          label='PAN'
                        />
                        <FormControlLabel
                          value={searchByTypes['GST']}
                          control={<Radio />}
                          label='GST'
                        />
                      </>
                    )}
                  </RadioGroup>
                </FormControl>
                <TextField
                  fullWidth
                  placeholder={`Search by ${
                    searchByPhone
                      ? 'Phone'
                      : searchByName
                      ? 'Name'
                      : searchByPan
                      ? 'PAN'
                      : searchByGst
                      ? 'GST'
                      : ''
                  }`}
                  variant='outlined'
                  sx={{ mb: 0.5 }}
                  value={enteredValue || ''}
                  error={!!errors.phone}
                  helperText={errors.phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    let regex;

                    if (value === '') {
                      setEnteredValue('');
                      setSelectedUser(null);
                      resetTableData();
                      setAllFoundCompanies([]);
                      setErrors({ ...errors, phone: null });
                      debouncedSearch.cancel(); // Cancel any pending debounced search
                      return;
                    }

                    if (searchByPhone) {
                      regex = /^[0-9]{0,10}$/;
                      if (value.length <= 10 && regex.test(value)) {
                        setEnteredValue(value);
                        if (errors.phone) {
                          setErrors({ ...errors, phone: null });
                        }
                        if (value.length >= 2) {
                          // Search with 3 or more digits in table data
                          debouncedSearch(value);
                        } else {
                          // For less than 3 digits, just reset search results
                          resetTableData();
                          setAllFoundCompanies([]);
                        }
                      }
                    } else if (searchByName) {
                      setEnteredValue(value);
                      if (value.length >= 3) {
                        debouncedSearch(value);
                      } else {
                        resetTableData();
                        setAllFoundCompanies([]);
                      }
                    } else if (searchByPan) {
                      regex = /^[a-zA-Z0-9]{0,10}$/;
                      if (value.length <= 10 && regex.test(value)) {
                        setEnteredValue(value);
                        if (value.length === 10) {
                          debouncedSearch(value);
                        } else if (value.length >= 2) {
                          debouncedSearch(value);
                        } else {
                          resetTableData();
                          setAllFoundCompanies([]);
                        }
                      }
                    } else if (searchByGst) {
                      regex = /^[a-zA-Z0-9]{0,15}$/;
                      if (value.length <= 15 && regex.test(value)) {
                        setEnteredValue(value);
                        if (value.length === 15) {
                          debouncedSearch(value);
                        } else if (value.length >= 2) {
                          debouncedSearch(value);
                        } else {
                          resetTableData();
                          setAllFoundCompanies([]);
                        }
                      }
                    } else {
                      setAllFoundCompanies([]);
                      resetTableData();
                    }
                  }}
                  {...(searchByPhone && {
                    type: 'text',
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  })}
                />
              </>
            )}
        </Card>
        {userNotFound && (
          <Row
            style={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={() => notFoundAction()}
              variant='contained'
            >
              Onboard Buyer
            </Button>
          </Row>
        )}

        {allFoundCompanies && allFoundCompanies.length > 0 && (
          <Box
            sx={{
              overflowY: 'scroll',
              height: 'auto',
            }}
          >
            {allFoundCompanies.map((user, index) => {
              return (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <strong>Name</strong>
                        </TableCell>
                        {!influencerTabSelected && (
                          <TableCell>
                            <strong>GST / PAN</strong>
                          </TableCell>
                        )}

                        <TableCell>
                          <strong>Phone</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Role</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={index}
                        hover
                        onClick={() => checkVCPClubbingLogic(user)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell>{user?.name || '-'}</TableCell>
                        {!influencerTabSelected && (
                          <TableCell>{user?.gstin_pan || '-'}</TableCell>
                        )}

                        <TableCell>{user?.phone_no || '-'}</TableCell>
                        <TableCell>
                          {user?.role_details?.display_name || '-'}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              );
            })}
          </Box>
        )}
        {isLoadingAllBuyers ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height={300}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            {allBuyers && allBuyers.length > 0 && (
              <Box sx={{ height: '50vh', overflowY: 'auto' }}>
                <Typography
                  variant='labelD'
                  sx={{ mb: 1 }}
                >
                  Select Below
                </Typography>
                <Box sx={{ mb: { xs: 1, sm: 2 }}}>
                  <Box sx={{}}>
                    <Tabs
                      value={activeTab}
                      onChange={(e, newValue) => setActiveTab(newValue)}
                      TabIndicatorProps={{ style: { display: 'none' } }}
                      sx={{
                        '& .MuiTabs-flexContainer': {
                          gap: 1,
                        },
                      }}
                    >
                      <CustomTab
                        value='My Network'
                        label='My Network'
                        active={activeTab === 'My Network'}
                        variant='primary'
                        type='standard'
                      />
                      {allBuyers
                        .filter(
                          (tab) =>
                            tab.display_name !== 'ACTIVE' &&
                            tab.display_name !== 'DORMANT' &&
                            tab.display_name !== 'My Network',
                        )
                        .map((section) => (
                          <CustomTab
                            key={section.display_name}
                            value={section.display_name}
                            label={section.display_name}
                            active={activeTab === section.display_name}
                            variant='primary'
                            type='standard'
                            tooltipText={section?.info_text || ''}
                          />
                        ))}
                    </Tabs>
                  </Box>
                </Box>

                {getCurrentTabData() && (
                  <Box sx={{ mb: 3 }}>
                    <TableContainer sx={{ mb: 2 }}>
                      <Table sx={{
                        tableLayout: !influencerTabSelected ? 'auto' : 'fixed',
                        width: '100%',
                        }}>
                        <TableHead>
                          <TableRow
                            sx={{
                              backgroundColor: '#0D0D0D14',
                              '& th:first-of-type': {
                                borderTopLeftRadius: { xs: '8px', sm: '16px' },
                              },
                              '& th:last-of-type': {
                                borderTopRightRadius: { xs: '8px', sm: '16px' },
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                width: '25%',
                                padding: { xs: 1, sm: 3 },
                                borderBottom: 'none',
                              }}
                            >
                              <Typography variant='labelS'>Firm Name</Typography>
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: { xs: 1, sm: 3 },
                                borderBottom: 'none',
                              }}
                            >
                              <Typography variant='labelS'>Phone</Typography>
                            </TableCell>
                            {/* {!influencerTabSelected && (
                                  <TableCell sx={{ padding: { xs:1, sm: 3}, borderBottom: 'none', }}>
                                    <Typography variant='labelS'>Onboarding Type</Typography>
                                  </TableCell>
                                )} */}
                            {influencerTabSelected && (
                              <TableCell
                                sx={{
                                  padding: { xs: 1, sm: 3 },
                                  borderBottom: 'none',
                                  
                                }}
                              >
                                <Typography variant='labelS'>Status</Typography>
                              </TableCell>
                            )}
                            <TableCell
                              sx={{
                                width: {xs: '25%' , sm: 'auto'},
                                padding: { xs: 1, sm: 3 },
                                borderBottom: 'none',
                              }}
                            >
                              <Typography variant='labelS'>Billing</Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#FFF' }}>
                          {getCurrentTabData().data &&
                          getCurrentTabData().data.length > 0 ? (
                            getCurrentTabData().data.map((row, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  cursor: 'pointer',
                                  backgroundColor:
                                    selectedUser?.company_phone_number ===
                                    row.company_phone_number
                                      ? '#995A000D'
                                      : 'transparent',
                                  transition: 'all 0.2s ease-in-out',
                                  boxShadow:
                                    selectedUser?.company_phone_number ===
                                    row.company_phone_number
                                      ? 'inset 0px 0px 0px 1px #995A00'
                                      : 'inset 0px 0px 0px 1px #0000',
                                  '&:hover': {
                                    boxShadow: 'inset 0px 0px 0px 1px #995A00',
                                    backgroundColor:
                                      selectedUser?.company_phone_number ===
                                      row.company_phone_number
                                        ? '#995A000D'
                                        : '#F49D3F0D',
                                  },
                                }}
                                onClick={() => {
                                  handleExistingShipToPartyClick(row);
                                }}
                              >
                                <TableCell
                                  sx={{
                                    padding: { xs: 1, sm: 2 },
                                    borderBottom: 'none',
                                    maxWidth: 200
                                  }}
                                >
                                  <Typography variant='p3' noWrap>
                                    {row.company_name}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: { xs: 1, sm: 2 },
                                    borderBottom: 'none',
                                  }}
                                >
                                  <Typography variant='p3'>
                                    {row.company_phone_number}
                                  </Typography>
                                </TableCell>
                                {/* {!influencerTabSelected && (
                                      <TableCell sx={{ padding: {xs:1, sm: 2}, borderBottom: 'none' }}>
                                        <Typography variant='p3'>
                                          {row.onboarding_type}
                                        </Typography>
                                      </TableCell>
                                    )} */}
                                {influencerTabSelected && (
                                  <TableCell
                                    sx={{
                                      padding: { xs: '10px', sm: 2 },
                                      borderBottom: 'none',
                                    }}
                                  >
                                    <StatusChip
                                      type='outlined'
                                      label={row.status}
                                      status={row.status}
                                      sx={{ px: {xs: 0.5 , sm: 2},
                                        '& .MuiChip-label': {
                                          px: { xs: 0 }
                                        },
                                       }}
                                    />
                                  </TableCell>
                                )}
                                <TableCell
                                  sx={{
                                    padding: { xs: 1, sm: 2 },
                                    borderBottom: 'none',
                                    width: { xs: '20%' , sm: 'auto'},
                                  }}
                                >
                                  <Typography variant='p3'>
                                    {row.billing || '-'}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={influencerTabSelected ? 4 : 4}
                                align='center'
                                sx={{ padding: 4, borderBottom: 'none' }}
                              >
                                <Typography variant='p2'>
                                  No data found
                                </Typography>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </Box>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default SelectSTP;
